import { render, staticRenderFns } from "./BackupSteps.vue?vue&type=template&id=003c05c2"
import script from "./BackupSteps.vue?vue&type=script&lang=js"
export * from "./BackupSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports